
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { TabItem } from '@/features/common/components/BaseTabs.vue';
import ShipmentDetails from '@/features/shipment-history/components/details/shipmentDetails/ShipmentDetails.vue';
import TrackingDetails from '@/features/shipment-history/components/details/trackingDetails/TrackingDetails.vue';
import {
  getShipment, getTrackingDetails,
} from '@/features/shipment-history/services/shipment-history.services';
import { showErrorAlertDialog } from '@/features/common/helpers';
import { HistoryItemType, TrackingDetailsType } from '@/features/shipment-history/types';
import { EncodedMapImages, getShipmentMaps } from '@/features/shipment-history/helpers';
// import Comments from '@/features/shipment-history/components/details/comments/Comments.vue';
import CopyToClipboardButton from '@/features/common/components/CopyToClipboardButton.vue';
import SidePanel from '@/features/common/components/SidePanel.vue';

@Component({
  components: {
    ShipmentDetails,
    TrackingDetails,
    CopyToClipboardButton,
    SidePanel,
    // Comments,
  },
})
export default class DetailsAside extends Vue {
  @Prop({ required: true }) carrierTrackingNumber!: string;

  @Prop({ required: true }) trackingNumber!: string;

  @Prop({ default: 'details' }) initTab!: string;

  private tabs: TabItem[] = [
    {
      name: 'details',
      title: this.$t('history.tabNames.details') as string,
    },
    {
      name: 'tracking',
      title: this.$t('history.tabNames.tracking') as string,
    },
    // {
    //   name: 'comments',
    //   title: this.$t('history.tabNames.comments') as string,
    // },
  ]

  private activeTabName = this.initTab;

  private isVisible = true;

  private isShipmentLoading = false;

  private isTrackingLoading = false;

  private shipment: HistoryItemType | null = null;

  private trackingDetails: TrackingDetailsType | null = null;

  private encodedMapImages: EncodedMapImages = {
    from: '',
    to: '',
  }

  @Watch('initTab')
  private replaceTab(): void {
    this.activeTabName = this.initTab;
  }

  @Watch('trackingNumber', { immediate: true })
  private async fetchItem(): Promise<void> {
    this.isShipmentLoading = true;

    const itemRes = await getShipment(this.trackingNumber);

    if (!itemRes) {
      showErrorAlertDialog();
      this.isShipmentLoading = true;
      return;
    }

    const { fromAddress, toAddress } = itemRes as HistoryItemType;
    const { fromMap, toMap } = await getShipmentMaps(fromAddress, toAddress);

    this.shipment = itemRes;
    this.encodedMapImages.from = fromMap;
    this.encodedMapImages.to = toMap;
    this.isShipmentLoading = false;
  }

  @Watch('carrierTrackingNumber', { immediate: true })
  private async fetchTrackingDetails(): Promise<void> {
    this.isTrackingLoading = true;

    const res = await getTrackingDetails(
      this.trackingNumber,
      this.carrierTrackingNumber,
    );

    if (!res) {
      showErrorAlertDialog(this.$t('history.alertDialog.trackingIsNotAvailable'));
    }

    this.isTrackingLoading = false;
    this.trackingDetails = res;
  }

  private mounted(): void {
    this.windowResizeHandler();
    window.addEventListener('resize', this.windowResizeHandler);
  }

  private beforeDestroy(): void {
    document.documentElement.style.overflow = '';

    window.removeEventListener('resize', this.windowResizeHandler);
  }

  private windowResizeHandler = () => {
    if (window.innerWidth <= 545) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
    }
  }

  private isActiveTab(name: string): boolean {
    return this.activeTabName === name;
  }

  private changeTab({ name }: TabItem): void {
    this.activeTabName = name as string;
  }

  private closeDetails(): void {
    this.isVisible = false;
  }

  private openDetailsPage(): void {
    const { href } = this.$router.resolve(
      {
        name: 'history-details',
        query: {
          id: this.trackingNumber,
          trackingNumber: this.carrierTrackingNumber,
        },
      },
    );

    window.open(href, '_blank');
  }
}
